import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core'
import { removeToolTip } from 'src/app/_helpers/Utils'
import { Section } from 'src/app/models/Reports'

@Component({
	selector: 'app-select-sections',
	templateUrl: './select-sections.component.html'
})
export class SelectSectionsComponent implements OnInit, OnDestroy {

	@Input() public allSectionsToManagement: Array<Section> = []
	@Input() public sectionsFromParent: Array<Section> = []
	@Output() public closeSelector = new EventEmitter<Array<Section>>()

	public sectionsSelected: Array<Section> = []

	public companyId = localStorage.getItem('companyId')

	public async ngOnInit(): Promise<void> {
		document.body.style.overflow = 'hidden'

		this.sectionsFromParent.forEach(sectionParent => {
			const sectionFind =
				this.allSectionsToManagement.find(section => section.id === sectionParent.id)

			if (sectionFind) {
				this.sectionsSelected.push(sectionFind)
			}
		})
	}

	public selectSection(section: Section) {
		const sectionAlreadySelected =
			this.sectionsSelected.find(sectionSeclected => sectionSeclected.id == section.id)

		if (sectionAlreadySelected) return

		this.sectionsSelected.push(section)
	}

	public unSelectSection(indexSelected: number) {
		if (this.sectionsSelected.length == 1 ) return

		this.sectionsSelected.splice(indexSelected, 1)
	}

	public closeSections() {
		this.closeSelector.emit(this.sectionsSelected)
		removeToolTip()
	}

	public ngOnDestroy(): void {
		document.body.style.overflow = 'auto'
	}
}
